'use client'
import NavigateDownIcon from '@/app/icons/navigate-down'
import NavigateUpIcon from '@/app/icons/navigate-up'
import { cn } from '@/util/cn'
import { useState } from 'react'

const NumberInput = ({ label, name, className }: { label: string; name: string; className?: string }) => {
    const [value, setValue] = useState(0)
    return (
        <div className={cn('bg-giphyDarkGrey flex items-center gap-4 p-2', className)}>
            <div className={'bg-giphyDarkestGrey flex w-fit gap-2 p-2'}>
                <input
                    type="number"
                    name={name}
                    className={'number-input bg-giphyDarkestGrey text-giphyLightGrey w-6 bg-giphyDarkestGrey/0'}
                    placeholder="0"
                    value={value}
                    readOnly
                />
                <div className="flex flex-col gap-1">
                    <div>
                        <NavigateUpIcon
                            className="fill-giphyBlue size-3 cursor-pointer"
                            onClick={() => {
                                setValue(value + 1)
                            }}
                        />
                    </div>
                    <div>
                        <NavigateDownIcon
                            className="fill-giphyBlue size-3 cursor-pointer"
                            onClick={() => {
                                setValue(Math.max(0, value - 1))
                            }}
                        />
                    </div>
                </div>
            </div>
            <label className="px-2 font-bold">{label}</label>
        </div>
    )
}

export default NumberInput
